import { Navigate } from 'react-router-dom';
import { useStore } from '../../store';
import { useGetWorkspaces } from './workspace.queries';

export function AutoWorkspaceRedirect() {
  const { data: workspaces, isLoading } = useGetWorkspaces();
  const logout = useStore((state) => state.logout);
  const setWorkspaces = useStore((state) => state.setWorkspaces);

  // If still loading, show nothing
  if (isLoading) {
    return null;
  }

  // If no workspaces, logout
  if (!workspaces || workspaces.length === 0) {
    logout();
    return null;
  }

  // Store workspaces in global state
  setWorkspaces(workspaces);

  // Redirect to first workspace
  return <Navigate to={`/${workspaces[0].id}`} replace />;
}
